import { Button, Checkbox } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './StartDialogWithAI.module.scss';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setIsUploadingSomeChat } from 'store/slices/windowStateSlice';
import { createChat, fetchSetSelectedChat } from 'store/reducers/chatCreator';
import api from 'api';
import { setEditorTokenDetails } from 'store/slices/aiFunctionsDataSlice';

type AIDialogProps = { };

const StartDialogWithAI = ({}: AIDialogProps) => {
  const [ai_can_view_document, set_ai_can_view_document] = React.useState(true);
  const [isCheckedChat, setIsCheckedChat] = React.useState(false);

  const { selectedDocument } = useAppSelector((state) => state.documents);
  const { dataRoom } = useAppSelector((state) => state.dataRoom);
  const { userData } = useAppSelector((state) => state.userData);
  const { currentEditorToken } = useAppSelector((state) => state.aiFunctions);
  const { selectedChat } = useAppSelector((state) => state.chat);

  const dispatch = useAppDispatch();  
  const { t } = useTranslation();

  React.useEffect(() => {
    !selectedChat && currentEditorToken && checkIsAIChatExist(currentEditorToken);
  }, [currentEditorToken]);

  const checkIsAIChatExist = async (currentEditorToken: string) => {
    try {
      const chatData = await api.getChatAIAssistant({ access_token: currentEditorToken });
      chatData.data?.id && startAI(Boolean(chatData.data?.id));
      try {
        const editingTokenDetails = await api.checkEditingToken(currentEditorToken);
        dispatch(setEditorTokenDetails(editingTokenDetails.data));
      } catch (e) {
        console.log(e, '< error of checking editing_token');
      }
    } catch {
      console.log('Result of the check of the chat with the AI assistant: chat not found'); 
    } finally {
      setIsCheckedChat(true);
    }
  }

  const startAI = async (exist?: boolean) => {    
    if(!selectedDocument || selectedDocument?.status === 0 || selectedDocument?.deleted_at) return;

    dispatch(setIsUploadingSomeChat(true));
    const chatInfo = await dispatch(
      createChat({
        data: {
          entity_type: 6,
          entity_id: currentEditorToken,
          members_ids: dataRoom?.available_users?.map(({ id }) => id)!,
          title: selectedDocument?.name || '',
          room_id: dataRoom?.id!,
        },
        ownerId: userData?.id!,
      })
    );

    if (!exist) {
      try {
        await api.updateEditingToken(currentEditorToken!, {ai_can_view_document, ai_model_type: 'flash'});
        dispatch(setEditorTokenDetails({ai_can_view_document, ai_model_type: 'flash'}));
      } catch (e) {
        console.log(e, 'error updateEditingToken');
      }
    }

    dispatch(setIsUploadingSomeChat(false));
    dispatch(fetchSetSelectedChat((chatInfo.payload as any).chat));
    
  };

  const onClickStart = () => {
    startAI();
  }

  return (
    <div>
      <Button disabled={!selectedChat && !isCheckedChat} onClick={onClickStart} type='primary'>{t('Chats.aiStart')}</Button>
      {isCheckedChat && <Checkbox
        checked={ai_can_view_document}
        className={classes.aiTip}
        onChange={(e) => set_ai_can_view_document(e.target.checked)}
      >
        {t('Chats.aiTip')}
      </Checkbox>}
    </div>
  );
}

export default StartDialogWithAI;
